"use client"

import * as React from "react"
import { getImageUrl } from "@/lib/images"
import { cn } from "@/lib/utils"

interface S3ImageProps extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src'> {
  src: string | null | undefined
}

/**
 * Image component that automatically transforms relative S3 paths to full URLs
 */
const S3Image = React.forwardRef<HTMLImageElement, S3ImageProps>(
  ({ className, src, alt, ...props }, ref) => {
    const fullUrl = getImageUrl(src)

    if (!fullUrl) return null

    return (
      <img
        ref={ref}
        className={cn(className)}
        src={fullUrl}
        alt={alt || ""}
        {...props}
      />
    )
  }
)
S3Image.displayName = "S3Image"

export { S3Image }
